import React, { useState, useEffect } from "react";
import axios from "axios";
import {PHP_API} from "../../../utils/Common";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import MyLoader from "../../sharecomponents/MyLoader";
import ActividadDetallesGenerales from "./components/ActividadDetallesGenerales";

const ReporteHoras = (props) => {
  const id = props.match.params.id;

  useEffect(() => {
    getInvenario();
  }, []);

  const [inventario, setInventario] = useState(null);
  const [loader, setLoader] = useState(false);

  const resultados = (labor,uhora) => {
    let min = (labor.lunes/uhora/8) + 
    (labor.martes/uhora/8) + 
    (labor.miercoles/uhora/8) + 
    (labor.jueves/uhora/8) + 
    (labor.viernes/uhora/8) + 
    (labor.sabado/uhora/8) + 
    (labor.domingo/uhora/8);
    let max = Math.ceil(labor.lunes/uhora/8) + 
    Math.ceil(labor.martes/uhora/8) + 
    Math.ceil(labor.miercoles/uhora/8) + 
    Math.ceil(labor.jueves/uhora/8) + 
    Math.ceil(labor.viernes/uhora/8) + 
    Math.ceil(labor.sabado/uhora/8) + 
    Math.ceil(labor.domingo/uhora/8);
    let charolas = labor.lunes + 
    labor.martes + 
    labor.miercoles + 
    labor.jueves + 
    labor.viernes + 
    labor.sabado + 
    labor.domingo;

    return `${charolas} / ${(charolas / uhora).toFixed(2)} / ${min.toFixed(2)} - ${max}`;
    
  }

  function getInvenario() {
    setLoader(true);
    axios.get(PHP_API + 'nomina/get-inventario', { params: { id } })
      .then(({data: {data}}) => {
        // const { inventario } = r.data;
        const { labores } = data;
        console.log(data)
        setInventario(data);
        setLoader(false);
      }).catch(e => setLoader(false));
  } // -- getInventario

  return (
    <React.Fragment>
      <div className="w-full p-3 right-0">
        <div className="bg-white border rounded shadow-xl">
          <div className="border-b rounded-t p-3 bg-orange-900">
            <HeadRegresar titulo="Reporte de Horas" history={props.history} />
          </div>
          <div className="p-5 pt-2 ">
          <ActividadDetallesGenerales inventario ={inventario} />
            <div className="table-container">
            <table className='table table-sm table-striped table-bordered table-hover'>
              <thead>
                <tr className="text-center">
                  <th>Labor / Actividad</th>
                  <th>Lunes</th>
                  <th>Martes</th>
                  <th>Miércoles</th>
                  <th>Jueves </th>
                  <th>viernes</th>
                  <th>Sábado</th>
                  <th>Domingo</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {inventario &&
                  inventario.labores.map((labor, i) => (
                    <tr key={i} className="text-s text-center">
                      <td className="text-left text-bold text-uppercase">{labor.labor} <span className="ml-3 text-xs text-primary text-300">{labor.unidad_hora} {labor.unidad} p/ hora</span></td>
                      <td >{labor.lunes}  / {(labor.lunes/labor.unidad_hora).toFixed(2)} / <span style={{fontWeight:'bold'}}>{(labor.lunes/labor.unidad_hora/8).toFixed(2)}</span></td>
                      <td >{labor.martes} / {(labor.martes/labor.unidad_hora).toFixed(2)} / <span style={{fontWeight:'bold'}}>{(labor.martes/labor.unidad_hora/8).toFixed(2)}</span></td>
                      <td >{labor.miercoles} / {(labor.miercoles/labor.miercoles).toFixed(2)} / <span style={{fontWeight:'bold'}}>{(labor.miercoles/labor.unidad_hora/8).toFixed(2)}</span></td>
                      <td >{labor.jueves} / {(labor.jueves/labor.unidad_hora).toFixed(2)} / <span style={{fontWeight:'bold'}}>{(labor.jueves/labor.unidad_hora/8).toFixed(2)}</span></td>
                      <td >{labor.viernes} / {(labor.viernes/labor.unidad_hora).toFixed(2)} / <span style={{fontWeight:'bold'}}>{(labor.viernes/labor.unidad_hora/8).toFixed(2)}</span></td>
                      <td >{labor.sabado} / {(labor.sabado/labor.unidad_hora).toFixed(2)} / <span style={{fontWeight:'bold'}}>{(labor.sabado/labor.unidad_hora/8).toFixed(2)}</span></td>
                      <td >{labor.domingo} / {(labor.domingo/labor.unidad_hora).toFixed(2)} / <span style={{fontWeight:'bold'}}>{(labor.domingo/labor.unidad_hora/8).toFixed(2)}</span></td>
                      <th >{resultados(labor,labor.unidad_hora)}</th>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
      {loader && <MyLoader/>}
    </React.Fragment>
  )

  
}

export default ReporteHoras;